/* eslint-disable */
/* tslint:disable */
// @ts-ignore
export default {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M14.587 14.363l30.406 30.406-3.194 3.194-2.724-2.724C36.473 46.61 31.889 48 24 48 8.426 48 5.735 42.584 5.735 42.584v-1.177c0 .101 0 .067.034-.841.199-10.86 1.743-14.08 12.532-16.102L1.795 7.958l3.194-3.193 9.598 9.598zm16.844 10.456c7.441 1.661 9.78 4.212 10.503 10.504zM14.57 7.958C15.211 3.351 17.447.027 24 0c8.241 0 9.654 5.247 9.654 11.739 0 4.443-2.017 8.304-5.005 10.298z"/>'
}
